import { forwardRef } from 'react';
import type { Ref } from 'react';

import type { TamaguiElement } from '@tamagui/core';

import { Box } from './Box';
import type { BoxProps } from './Box';

export type ColProps = BoxProps;

/**
 * Col is a convenience component that renders a Box with flexDirection set to 'column'.
 * It accepts all the same props as Box.
 * Note: Box already defaults to flexDirection='column', so Col is primarily useful
 * for semantic clarity or when you need to explicitly override a parent's flexDirection.
 */
export const Col = forwardRef(function Col(props: ColProps, ref: Ref<TamaguiElement>) {
  return <Box ref={ref} flexDirection="column" {...props} />;
});
